<template>
  <div class="REDIRECT">
    <h1 class="h3 m-b-3" selenium="Home-Depot-Redirect-Header">
      Good news! We have your project covered.
    </h1>
    <div selenium="HDRedirect-bullets">
      <div class="m-b-3">Connecting you in {{ duration }} seconds</div>
      <spinner class="m-b-3 m-x-auto"/>
    </div>
    <a
        class="btn btn-lg w-100:mo m-b-1 m-b-3:t"
        selenium="HDRedirect-button"
        @click="redirectClicked">
      Get Started
    </a>
  </div>
</template>

<script>
export default {
  name: 'redirect',
  props: {
    redirect_url: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      duration: 5,
      redirectionTimer: null,
    };
  },
  mounted () {
    this.redirectionTimer = setInterval(this.updateTime, 1000);
    this.$events.$emit(this.$events.REQUEST_HD_REDIRECT);
  },
  beforeDestroy () {
    clearInterval(this.redirectionTimer);
  },
  methods: {
    updateTime () {
      this.duration -= 1;
      if (this.duration < 1) {
        clearInterval(this.redirectionTimer);
        this.redirectClicked();
      }
    },
    redirectClicked () {
      this.$events.$emit(this.$events.REQUEST_HD_REDIRECT_COMPLETE);
      window.location.href = `${this.redirect_url}?source=proreferral`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@homeservices/design-kit/tools';

.REDIRECT {
  @include container();
  text-align: center;

  @include mobile-only() {
    @include padding-x(1);
  }

  @include tablet() {
    max-width: 650px;
  }
}

.LOGO {
  @include square(80px);
  @include margin-top(3, 6);
  @include margin-bottom(1, 3);
}
</style>
